export const SIZE = 50;



// WEBPACK FOOTER //
// ./src/utils/Constants.js